import {axios} from ".";
import config from '../config.json';
import { toast } from "react-toastify";

export const login = async (username, password) => {
  try{
    const {
      data
    } = await axios.post(`${config.base_url_api}/user/login`, {
      username,
      password
    });
    toast.success("Signed in successfully!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      });
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
};
export const updateUserTemplate = async (userID, template) => {
  try{
    const {
      data
    } = await axios.put(`${config.base_url_api}/user/${userID}`,{template: template});
    return data;
  }catch(error)
  {
    throw new Error(error)
  }
}
export const getUserById = async (userID) => {
  const {
    data
  } = await axios.get(`${config.base_url_api}/user/${userID}`);
  return data;
}